import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { isNumeric } from '../../utils/Numeric';
import {
  message, Modal,
  Affix,
  Checkbox, Select, Button, Tabs
} from 'antd';
import moment from 'moment';
import {
  UploadOutlined,
  ExclamationCircleOutlined,
  CheckCircleTwoTone,
  DiffOutlined,
  SyncOutlined,
  PlusCircleFilled,
  PlusCircleOutlined
} from '@ant-design/icons';
import { getGoodsBySpecName } from '../../services/Goods';
import {
  getList,
  insert,
  update,
  insertGoods,
  insertGoodsPrice,
  getGoodsList,
  getGoodsAndPriceList
} from '../../services/Supplier';

import { getDatetime } from '../../services/Login';
export default React.forwardRef((props, ref) => {
  const { onCloseCallback, reload, country, currency } = props;
  const columns0 = ['#', '名称', '拼音缩写', '国家', '货币', '详细地址', '联系人', '电话', '邮箱', '备注', '是否公开价格']
  const columns = ['#', '产品号', '价格', '计划生效时间(不填表示即时生效)']
  const [fileName, setFileName] = useState('');
  const [rows, setRows] = useState([]);
  const [isShowSyncDb, setShowSyncDb] = useState(false);
  const [datetime, setDatetime] = useState(undefined);
  const [suppliers, setSuppliers] = useState([]);

  const [isChecking, setChecking] = useState(false);
  const [isSyncing, setSyncing] = useState(false);
  useEffect(() => {
    getDatetime().then(data => setDatetime(data));
    getList().then(data => setSuppliers(data));
  }, [])

  const syncSupplierDB = async () => {
    setSyncing(true);
    const key = 'update_goods';
    const temp = [].concat(rows);
    const arr = [];
    if (temp.length > 0) {
      const insertArr = rows[0].data.filter(x => x.status === 1);
      insertArr.forEach(x => {
        arr.push(new Promise((resolve, reject) => {
          insert(x).then(data => {
            x.status = 0;
            x._id = data.id;
            resolve(true);
          })
        }))
      })
      const updateArr = rows[0].data.filter(x => x.status === 2);
      updateArr.forEach(x => {
        arr.push(new Promise((resolve, reject) => {
          update(x._id, x).then(data => {
            x.status = 0;
            resolve(true);
          })
        }))
      })
    }

    Promise.all(arr).then(values => {
      getList().then(dataSuppliers => {
        setSuppliers(dataSuppliers);
        const arr1 = [];
        const arr2 = [];
        const arr3 = [];
        for (let i = 1; i < rows.length; i++) {
          const name = rows[i].name;
          const supplierId = (dataSuppliers.find(x => x.name === name) || {}).id;
          if (supplierId) {
            const objs = rows[i].data.filter(x => x.status === 2);
            if (objs.length > 0) {
              const tempObjs = [];
              objs.forEach(x => {
                if (tempObjs.find(y => y.goods_id === x.goods_id && y.goods_spec_id === x.goods_spec_id)) {

                } else {
                  tempObjs.push({ goods_id: x.goods_id, goods_spec_id: x.goods_spec_id })
                }
              })
              arr1.push(new Promise((resolve, reject) => {
                insertGoods(supplierId, tempObjs.filter(o => o.goods_id && o.goods_spec_id)).then(data => {
                  resolve(true);
                })
              }));
              objs.forEach(x => {
                arr2.push(new Promise((resolve, reject) => {
                  message.loading({ content: `正在更新价格${x.name}...`, key });
                  insertGoodsPrice(supplierId, x.goods_id, x.goods_spec_id, x).then(data => {
                    objs.forEach(o => o.status = 0);
                    resolve(true);
                  })
                }));
              })
            }
            const objs3 = rows[i].data.filter(x => x.status === 3);
            objs3.forEach(x => {
              arr3.push(new Promise((resolve, reject) => {
                message.loading({ content: `正在更新价格${x.name}...`, key });
                insertGoodsPrice(supplierId, x.goods_id, x.goods_spec_id, x).then(data => {
                  objs3.forEach(o => o.status = 0);
                  resolve(true);
                })
              }));
            })
          }
        }
        Promise.all(arr1).then(values => {
          Promise.all(arr2).then(values => {
            Promise.all(arr3).then(values => {
              setRows(temp);
              reload();
              setSyncing(false);
              message.success({ content: `同步完成 [ ${values.length}] 条数据 `, key, duration: 1 });
            })
          })
        });
      });
    });
  }

  const initRows = () => {
    if (rows.length === 0) return;
    const list = rows[0].data;
    list.forEach((x, i) => {
      const name = (x[columns0[1]] || '').trim();
      const abbr = (x[columns0[2]] || '').trim();
      const country_id = (country.find(y => y.name_cn === (x[columns0[3]] || '').trim()) || {}).id || -1;
      const currency_id = (currency.find(y => y.name === (x[columns0[4]] || '').trim()) || {}).id || -1;
      const address = (x[columns0[5]] || '-').trim();
      const contact = (x[columns0[6]] || '-').trim();
      const tel = (x[columns0[7]] + '-').trim();
      const email = (x[columns0[8]] || '-').trim();
      const remark = (x[columns0[9]] || '-').trim();
      const isPublicPrice = (x[columns0[10]] || '').trim();
      x.idx = i;
      x.name = name;
      x.country_id = country_id;
      x.currency_id = currency_id;
      x.address = address;
      x.contact = contact;
      x.tel = tel;
      x.email = email;
      x.remark = remark;
      x.abbr = abbr;
      x.is_open_price = isPublicPrice === '是' ? true : false;
      if (name.length === 0) {
        x.status = -1;
      } else {
        x.status = undefined;
      }
    });

    for (let i = 1; i < rows.length; i++) {
      const list = rows[i].data;
      list.forEach((x, idx) => {
        const name = (x[columns[1]] + '').trim();
        const price = isNumeric(x[columns[2]]) ? parseFloat(x[columns[2]]) : undefined;
        const start_time = (x[columns[3]] || '').trim();
        x.idx = i;
        if (name.length === 0) {
          x.status = -1;
        } else {
          x.status = undefined;
        }
        x.name = name;
        x.price = price;
        x.start_time = start_time.length === 0 ? datetime : start_time;
        x.end_time = '2099-12-31 23:59:59';
      });
      rows[i].goods = [];
      rows[i].status = 0;
    }
  }

  const checkExistsData = (callback) => {
    if (rows.length === 0) return;
    const list = rows[0].data;
    list.forEach((x, i) => {
      const find = suppliers.find(y => y.name === x.name);
      if (find) {
        x.status = 0;
        x._country_id = find.country_id;
        x._currency_id = find.currency_id;
        x._address = find.address;
        x._tel = find.tel;
        x._email = find.email;
        x._contact = find.contact;
        x._remark = find.remark;
        x._abbr = find.abbr;
        x._is_open_price = find.is_open_price;
        x._id = find.id;
        if (x.country_id !== find.country_id ||
          x.currency_id !== find.currency_id ||
          x.address !== find.address ||
          x.tel !== find.tel ||
          x.email !== find.email ||
          x.contact !== find.contact ||
          x.remark !== find.remark ||
          x.abbr !== find.abbr ||
          x.is_open_price !== find.is_open_price) {
          x.status = 2;
        }
      } else {
        x.status = 1;
      }
    });

    const arr = [];
    for (let i = 1; i < rows.length; i++) {
      const name = rows[i].name;
      const find = suppliers.find(x => x.name === name);
      if (find) {
        arr.push(
          new Promise((resolve, reject) => {
            getGoodsAndPriceList(find.id).then(data => {
              rows[i].goods = data;
              resolve(true);
            })
          })
        )
      }
    }

    Promise.all(arr).then(values => {
      for (let i = 1; i < rows.length; i++) {
        const data = rows[i].data;
        const goods = rows[i].goods;
        data.filter(x => x.status === undefined).forEach(x => {
          const find = goods.find(y => y.goods_spec_name === x.name);
          if (find && find.price) {
            if (Math.abs(x.price - find.price) > 0.000001) {
              x.status = 3;
              x._price = find.price;
            } else {
              x.status = 0;
            }
            x.goods_id = find.goods_id;
            x.goods_spec_id = find.goods_spec_id;
          } else {
            x.status = 2;
          }
        });
      }
      callback && callback();
    })

  }

  const checkGoodsTable = (callback) => {
    const goods = [];
    for (let i = 1; i < rows.length; i++) {
      const temp = rows[i].data.filter(x => x.status === 2);
      temp.forEach(x => {
        if (!goods.find(y => y.name === x.name)) {
          goods.push(x);
        }
      })
    }

    const arr = [];
    const key = 'update_goods';
    goods.forEach(x => {
      const name = x.name;
      arr.push(
        new Promise(async (resolve, reject) => {
          message.loading({ content: `正在校验${name}...`, key });
          try {
            await getGoodsBySpecName(name).then(goodsData => {
              message.loading({ content: `正在校验${name}...`, key });
              x.goods_id = goodsData.goods_id;
              x.goods_spec_id = goodsData.id;
              resolve(true);
            });
          } catch (e) {
            x.status = 1;
            resolve(false);
          }
        })
      );
    })

    Promise.all(arr).then(values => {
      for (let i = 1; i < rows.length; i++) {
        const temp = rows[i].data.filter(x => x.status === 2);
        temp.forEach(x => {
          const find = goods.find(y => y.name === x.name);
          if (find) {
            x.goods_id = find.goods_id;
            x.goods_spec_id = find.goods_spec_id;
          }
        })
      }
      callback && callback();
      message.success({ content: `数据校验完成 [ ${values.length}] 条数据  `, key, duration: 1 });
    })
  }


  const checkSupplierDB = async () => {
    setChecking(true);
    initRows();
    checkExistsData(() => {
      checkGoodsTable(() => {
        const temp = [].concat(rows);
        setRows(temp);
        setChecking(false);
      })
    });
  }

  const onExportExcel = () => {
    // 获取表格的dom元素
    var elt = document.getElementById('import-table');
    // 将表格的dom 元素转化为 excel工作薄
    var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
    // 将工作薄导出为excel文件
    XLSX.writeFile(wb, '供应商产品.xlsx');
  }

  const onImportExcel = file => {
    // 获取上传的文件对象
    const { files } = file.target;
    if (files.length === 0) return;
    setFileName(files[0].name)
    // 通过FileReader对象读取文件
    const fileReader = new FileReader();
    fileReader.onload = event => {
      try {
        const { result } = event.target;

        // 以二进制流方式读取得到整份excel表格对象
        const workbook = XLSX.read(result, { type: 'binary' });
        // 存储获取到的数据
        // 遍历每张工作表进行读取（这里默认只读取第一张表）
        let i = 0;
        const temp = [].concat(rows);
        for (const sheet in workbook.Sheets) {
          // esline-disable-next-line
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            // 利用 sheet_to_json 方法将 excel 转成 json 数据
            let data = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
            temp[i] = { name: sheet, data: data };
            i++;
          }
        }
        setRows(temp);
        // 最终获取到并且格式化后的 json 数据
        message.success('导出文件完成！')
      } catch (e) {
        // 这里可以抛出文件类型错误不正确的相关提示
        message.error('文件类型不正确！');
      }
    };
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(files[0]);
  }

  const parseHeader = () => {
    const tds = [];
    columns.forEach(x => {
      tds.push(<th>{x}</th>);
    })
    return <tr>{tds}</tr>
  }

  const parseHeader0 = () => {
    const tds = [];
    columns0.forEach(x => {
      tds.push(<th>{x}</th>);
    })
    return <tr>{tds}</tr>
  }

  const parseRow = (row, i) => {
    const tds = [];
    columns.forEach((x, i) => {
      if (i === 1) {
        if (row.status === 0) {
          tds.push(<td className="td">{row[x]} <CheckCircleTwoTone twoToneColor="#52c41a" /></td>);
        } else if (row.status === -1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
        } else if (row.status === 1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#F50' }}>产品库不存在</span></td>);
        } else if (row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#FF8C00' }}>供应商库不存在</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 2) {
        if (row.status === 3) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._price})</span></td>);
        } else {
          if (row[x] <= 0.00001) {
            tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
          } else {
            tds.push(<td className="td">{row[x]}</td>);
          }
        }
      } else if (i === 3) {
        tds.push(<td className="td">{row[x] ? moment(row[x]).format('YYYY-MM-DD HH:mm:ss') : ''}</td>);
      } else {
        tds.push(<td className="td">{row[x]}</td>);
      }
    });
    return <tr>{tds}</tr>
  }

  const parseRow0 = (row, i) => {
    const tds = [];
    columns0.forEach((x, i) => {
      if (i === 1) {
        if (row.status === 0) {
          tds.push(<td className="td">{row[x]} <CheckCircleTwoTone twoToneColor="#52c41a" /></td>);
        } else if (row.status === -1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
        } else if (row.status === 1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#F50' }}> [新]</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 2) {
        if (row._abbr !== row.abbr && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 3) {
        if (row._country_id !== row.country_id && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 4) {
        if (row._currency_id !== row.currency_id && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 5) {
        if (row._address !== row.address && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._address})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 6) {
        if (row._contact !== row.contact && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._contact})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 7) {
        if (row._tel !== row.tel && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row[x]._tel})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 8) {
        if (row._email !== row.email && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._contact})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 9) {
        if (row._remark !== row.remark && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._remark})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 10) {
        if (row._is_open_price !== row.is_open_price && row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._is_open_price})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else {
        tds.push(<td className="td">{row[x]}</td>);
      }
    });
    return <tr>{tds}</tr>
  }

  let isSyncData = false;
  if (rows.length > 0) {
    isSyncData = rows[0].data.filter(x => x.status && x.status > 0).length > 0;
    if (!isSyncData) {
      for (let i = 1; i < rows.length; i++) {
        isSyncData = rows[i].data.filter(x => x.status && x.status > 1).length > 0;
        if (isSyncData) {
          break;
        }
      }
    }
  }

  return (
    <div className='goods-import-container'>
      <div className="goods-import-button-group">
        <div className='goods-import-file-name'> {fileName} </div>
        <div icon={<UploadOutlined />} className='upload-wrap'>
          <input className='file-uploader' type='file' accept='.xlsx, .xls' onChange={onImportExcel} />
          <span className='upload-text'>选择文件...</span>
        </div>
        <div className='upload-tip'>支持 .xlsx、.xls文件</div>
      </div>
      <div className="goods-import-filter-group">
        <div style={{ marginLeft: 'auto' }}></div>
        {
          (rows.length > 0) && <Affix offsetTop={92}>
            <Button icon={<DiffOutlined />} disabled={isSyncing} loading={isChecking} type="primary" onClick={() => checkSupplierDB()}>
              数据比对
            </Button>
            <Button loading={isSyncing} disabled={isChecking || !isSyncData} icon={<SyncOutlined />} type="primary" onClick={() => syncSupplierDB()}>
              数据库同步
            </Button>
            {fileName && <Button onClick={onExportExcel}>导出到Excel...</Button>}
          </Affix>
        }
      </div>
      <div className="goods-import-content">
        <Tabs type="card">
          {
            rows.map((x, i) => {
              if (i === 0) {
                return <Tabs.TabPane style={{ padding: '1rem' }} tab={x.name} key={i}>
                  <table id="import-table" border="1" className="goods_table">
                    {
                      x.data.length > 0 && parseHeader0(rows[0])
                    }
                    {
                      x.data.map((x, i) => parseRow0(x, i))
                    }
                  </table>
                </Tabs.TabPane>
              }
              const isExist = suppliers.find(y => y.name === x.name) !== undefined;
              return <Tabs.TabPane style={{ padding: '1rem' }} tab={x.status !== 1 ? x.name : <span><span>{x.name}</span><span style={{ color: 'red' }}> [新]</span></span>} key={i}>
                <table id="import-table" border="1" className="goods_table">
                  {
                    x.data.length > 0 && parseHeader(rows[0])
                  }
                  {
                    x.data.map((x, i) => parseRow(x, i))
                  }
                </table>
              </Tabs.TabPane>
            })
          }
        </Tabs>

      </div>
    </div >
  );
});